<template>
  <el-date-picker
    v-model="value"
    class="common-width"
    :picker-options="pickerOptions"
    :clearable="false"
    :editable="false"
    type="daterange"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    range-separator="-"
    value-format="yyyy-MM-dd"
    :default-value="new Date()"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
import moment from "moment";

export default {
  name: 'jlDatePicker',
  data() {
    return {
      value: this.dateValue,
      pickerOptions: {
        disabledDate(time) {
          return false;// moment(time).isAfter(moment().endOf('day'));
        },
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              picker.$emit('pick', [
                moment().startOf('day').format('YYYY-MM-DD'),
                moment().endOf('day').format('YYYY-MM-DD')
              ]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD'),
                moment().endOf('day').format('YYYY-MM-DD')
              ]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DD'),
                moment().endOf('day').format('YYYY-MM-DD')
              ]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(3, 'month').startOf('day').format('YYYY-MM-DD'),
                moment().endOf('day').format('YYYY-MM-DD')
              ]);
            }
          }]
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.$emit("update:dateValue", newVal);
    },
    dateValue: function (newVal) {
      this.value = newVal
    },
  },
  props: {
    dateValue: {
      type: Array,
      default: []
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/date-picker/general-date-picker.vue